export { default } from "./Talk";
